/** The ten charter sections, in charter order, as the backend keys them. */
export const CHARTER_SECTION_OPTIONS = [
  { key: 'project_overview', label: 'Project Overview' },
  { key: 'individual_goals_and_strengths', label: 'Individual Goals & Strengths' },
  { key: 'communication_plan', label: 'Communication Plan' },
  { key: 'deliverables_and_deadlines', label: 'Deliverables & Deadlines' },
  { key: 'roles_and_responsibilities', label: 'Roles & Responsibilities' },
  { key: 'conflict_resolution', label: 'Conflict Resolution' },
  { key: 'team_boundaries', label: 'Team Boundaries' },
  { key: 'operations', label: 'Operations' },
  { key: 'leadership_structure', label: 'Leadership Structure' },
  { key: 'resources_and_support', label: 'Resources & Support' },
] as const
